import styled, { CSSObject } from 'styled-components';
import { Link } from 'core/routing';

interface FrameStyledProps {
  active?: boolean;
}

export const TypeStyled = styled.span(({ theme }) => ({
  marginRight: theme.space[1],
  color: theme.color.primary,
  fontSize: theme.font.size.small,
  fontWeight: theme.font.weight.xbold,
}));

export const FrameTabStyled = styled.div<FrameStyledProps>(
  ({ theme, active }) => {
    let styleSheet: CSSObject = {
      marginBottom: `-${theme.space[1]}`,
      padding: `${theme.space[1]} ${theme.space[4]}`,
      fontSize: theme.font.size.small,
      lineHeight: theme.font.size.medium,
      marginRight: theme.space[1],
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'default',
      // background: theme.color.wfGrey100,
      color: theme.color.wfBlack,
      boxSizing: 'border-box',

      maxWidth: '300px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    };

    if (active) {
      styleSheet = {
        ...styleSheet,
        color: theme.color.wfBlack,
        background: theme.color.wfWhite,
      };
    }

    return styleSheet;
  },
);

export const SpanWithEllipsis = styled.span({
  display: 'block',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  paddingLeft: '2px',
});

export const SpanLinkWithEllipsis = styled(SpanWithEllipsis)({
  paddingLeft: '0px',
});

export const ProjectLinkStyled = styled(Link)(({ theme }) => ({
  color: 'black',
  ':hover': {
    color: theme.color.primary,
  },
  textDecoration: 'underline',
}));
